import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#333",
    },
    secondary: {
      main: "#444",
    },
  },
});
